// extracted by mini-css-extract-plugin
export default {"itemBlock":"tag_item_itemBlock__FUj1e","deleteIcon":"tag_item_deleteIcon__jiG9o"};